if (!customElements.get('shaker-upsell')) {
  customElements.define('shaker-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.toggle = this.querySelector('[data-shaker-toggle]');
      this.select = this.querySelector('[data-shaker-variant]');
      const update = () => {
        const form = document.getElementById(this.dataset.formId);
        form?.closest('product-form')?.classList.toggle('shaker-upsell-selected', this.toggle.checked);
        this.classList.toggle('is-selected', this.toggle.checked);
        this.toggle.setAttribute('aria-checked', String(this.toggle.checked));
        const option = this.select.selectedOptions[0];
        const image = this.querySelector('img');
        if (image && option?.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
          image.alt = option.dataset.alt || '';
        }
      };
      this.toggle.addEventListener('change', update);
      this.select.addEventListener('change', update);
      update();
    }
  });
}
